var $ = require('jquery');
var Handlebars = require('handlebars');
var bannerTemplate = require('./banner-template.hbs');
var discountTemplate = require('./discount-template.hbs');
var timer = require('../../helpers/timer')
var localeHelper = require("../../helpers/locale-helper");
var Session = require('../../signup_flow/user/session');

function injectDiscountBanner(element, options) {
  var discountValue = options.discountValue;
  var discountDuration = options.discountDuration;
  var timerInstance = timer.create(discountDuration);
  var time = timerInstance.getTime();

  var template = Handlebars.compile(bannerTemplate({
    linkUrl: localeHelper('/signup'),
    discountTimer: time.toString(),
    dataModal: 'signup',
    isLoggedIn: Session.instance.get('loggedIn')
  }));

  $(element).prepend(template({
    discountValue,
    discount: discountTemplate({
      discountValue,
    })
  }));

  var timerNode = $('.discount-banner__timer');

  timerInstance.on('change', function (timeObject) {
    timerNode.html(timeObject.toString());
  });

  timerInstance.on('finish', function () {
    $('.discount-banner').remove();
  });

  timerInstance.run();
}

module.exports = injectDiscountBanner;
